import useThemeContext from "@casino/legacy/client/hooks/theme/useThemeContext";
import { cn } from "@workspace/frontend-ui";

const CardBettingRangeDetail: FC = ({ children }) => {
  const { colorScheme } = useThemeContext();
  const backgroundColor =
    colorScheme === "light" ? "bg-background/[0.6]" : "bg-background/[0.04]";
  return (
    <div
      className={cn(
        "absolute bottom-0 flex h-4 w-full items-center justify-center rounded-b-lg left-0 right-0 text-center",
        "text-2xs-caption font-medium uppercase text-foreground backdrop-blur-[20px]",
        backgroundColor,
      )}
    >
      {children}
    </div>
  );
};
export default CardBettingRangeDetail;
